import React from 'react';
import find from 'lodash/find';
import { useState, useEffect, useContext } from 'react'
import { useDrop } from '../contexts/DropContext'
import { MDBTable, MDBTableHead, MDBTableBody, Card } from 'mdbreact';
import Popup from './Popup';
import myjson from "../assets/illusion_json.json";
import {matchSorter} from 'match-sorter';
import ReactTable from "react-table-6";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import {Tooltip as ReactTooltip} from "react-tooltip"
import "react-table-6/react-table.css";
import Button from './InitButton';
import DandiButton from './DandiButton';
import Raw_Button from './Raw_Button'
import NoteButton from './NoteButton';
import EditNoteButton from './EditNoteButton';
import ButtonGroup from './ButtonGroup';
import CellTip from './CellTip';
import './NewTable.css'
import illusion from '../assets/Illusion.png'
import glo from '../assets/glo.png'
import dendrite from '../assets/Dendrite.png'
import Tag from './Tag';
import MouseTable from './MouseTable';
import ToolTipHeader from './ToolTipHeader';
import "./PublicTable.css";
import { Link, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaBookOpen, FaExternalLinkAlt, FaGithub, FaRedo, FaSearch, FaTable, FaYoutube } from 'react-icons/fa';
import projects from '../data/projects.json';
import projectArtwork from '../data/projectArtwork';
import { getProjectWebinar } from '../data/projectWebinars';
import { countPublicSessions, loadProject, searchPublicSessions } from '../data/publicSessions';
import { getDatabookUrl } from './Dropdown';
import { getProjectGroups, getStimulusCode } from '../data/projectCatalogue';
import { safeExternalUrl } from '../data/safeUrl';


export default function NewTable({ projectId }) {

  const location = useLocation()
  const sessionTableRef = React.useRef(null)
    const [selectedValues, setSelectedValues] = useState([]);
    const [option, setSelectedOption] = useState("");
    const [sessions, setSessions] = useState([])
    const [filteredSessions, setFilteredSessions] = useState([])
    const [activeFilters, setActiveFilters] = useState([])
    const [currSess, setCurrSess] = useState(0)
    const [currExp, setCurrExp] = useState(0)
    const [editNotes, setEditNotes] = useState(false)
    const [desc, setDesc] = useState({})
    const [search, setSearch] = useState(null)
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState("")
    const [loadAttempt, setLoadAttempt] = useState(0)
    const [unavailableImages, setUnavailableImages] = useState({})
    const [dataSource, setDataSource] = useState(null)

    const [currentNotes, setCurrentNotes] = useState("")
    const currentDrop = useDrop().currentDrop
    const catalogueProject = projects.find(entry => projectId ? entry.id === projectId : entry.firebaseProject === currentDrop)
    const projectGroup = catalogueProject && getProjectGroups().find(group => group.id === (catalogueProject.projectId || catalogueProject.id))
    const multipleDatasets = projectGroup && projectGroup.datasets.length > 1
    const project = catalogueProject ? catalogueProject.firebaseProject || catalogueProject.id : currentDrop
    const artwork = catalogueProject && projectArtwork[catalogueProject.id]
    const databookUrl = catalogueProject && getDatabookUrl(catalogueProject)
    const stimulusCode = getStimulusCode(catalogueProject)
    const [isOpen, setIsOpen] = useState(false);
    const [definitions, setDefinitions] = useState(null)
    const queryClient = new QueryClient()
    const togglePopup = (notes, sessionID) => {
      setIsOpen(!isOpen);
      setEditNotes(notes)
      setCurrSess(sessionID)
      setCurrentNotes(notes)
    }
    const handleCurrentNotes = event => {
        setCurrentNotes(event.target.value)
    }
    useEffect(() => {
        console.log("UPDATED FILTER", filteredSessions);
        console.log("UPDATED VALUE", selectedValues)
        console.log("ACTIVE", activeFilters)
      }, [filteredSessions, selectedValues, activeFilters]);
    
    useEffect(() => {
      const controller = new AbortController()
      let active = true
      setLoading(true)
      setLoadError("")
      setUnavailableImages({})
      setDataSource(null)
      setSessions([])
      setDesc({})
      setDefinitions({})
      setFilteredSessions([])
      setActiveFilters([])
      setSelectedValues([])
      setSelectedOption("")
      loadProject(catalogueProject && catalogueProject.id, controller.signal).then(result => {
        if (!active) return
        setSessions(result.sessions)
        setDesc(result.description)
        setDefinitions(result.definitions)
        setDataSource({ label: result.source, retrievedAt: result.retrievedAt, draft: result.draft })
      }).catch(error => {
        if (active && error.name !== 'AbortError') setLoadError('Unable to load public sessions.')
      }).finally(() => {
        if (active) setLoading(false)
      })
      return () => {
        active = false
        controller.abort()
      }
    }, [project, catalogueProject, loadAttempt])
    useEffect(() => {
      if (!loading && !loadError && location.hash === '#public-sessions') {
        sessionTableRef.current?.scrollIntoView({ block: 'start' })
      }
    }, [loading, loadError, location.hash, project])
    const [status, setStatus] = useState([])
    const updateStatus = (newStatus, id) => {
        for (var i in sessions){
            if(sessions[i].sessionID == id) {
                sessions[i].status = newStatus
            }
        }
        setStatus(newStatus)
    }  

    const handleChange = (event, fieldName, filteredSessions) => {
        let newSelected = [...selectedValues, {field: fieldName, value: event.target.value}];
        console.log("NEW SELECTED", newSelected)
        setSelectedValues(newSelected);
        let newFilters = sessions.filter(session => {
          return newSelected.every(f => {
            if (f.field === 'fails' || f.field === 'overrides' || f.field=== 'flags') {
              return session[f.field].includes(f.value);
            } else {
              return session[f.field] === (f.value);
            }
          });
        });
        console.log("NEW_SELECTED", newFilters)
        setFilteredSessions(newFilters);
      };

    const handleSelect = (event, onChange, fieldName, filteredSessions) => {
        if (event.target.value === "") {
          for (let i = activeFilters.length - 1; i >= 0; i--) {
            if (activeFilters[i].field === fieldName) {
              activeFilters.splice(i, 1);
            }
          }
          for (let i = selectedValues.length - 1; i >= 0; i--) {
            if (selectedValues[i].field === fieldName) {
              selectedValues.splice(i, 1);
            }
          }
          setActiveFilters([...activeFilters]);
          setSelectedValues([...selectedValues]);
          filteredSessions = sessions.filter(session => {
            return activeFilters.every(f => session[f.field].includes(f.value));
          });
          setFilteredSessions([...filteredSessions]);
        } else {
          setSelectedValues([...selectedValues, { field: fieldName, value: event.target.value }], () => console.log("selectedValues", selectedValues));          
          setActiveFilters([...activeFilters, { field: fieldName, value: event.target.value }], () => console.log("ActiveFilters", activeFilters));
          handleChange(event, fieldName, filteredSessions);
        }
      };

    const customFilter = ({ fieldName, filter, onChange}) => {
        var val = ""
        console.log("fieldName", fieldName)
      
        for (var i = selectedValues.length - 1; i >= 0; i--) {
          if (selectedValues[i].field === fieldName) {
            val = selectedValues[i].value
          }
        }
        const filteredSessions = sessions.filter(session => {
          return activeFilters.every(f => session[f.field] === f.value);
        });
        if (fieldName === "flags" || fieldName === "overrides" || fieldName === "fails") {
          // Create an array of all unique tags in filteredSessions
          const allTags = Array.from(new Set(filteredSessions.flatMap(session => session[fieldName].split("/"))));
          console.log("ALLTAGS", allTags)
          return (
            <select
              onChange={event => {
                const selectedTag = event.target.value;
                // Filter filteredSessions based on whether each session has the selected tag
                const updatedFilteredSessions = filteredSessions.filter(session => session[fieldName].split("/").includes(selectedTag));
                console.log("UPDATED", updatedFilteredSessions)
                handleSelect(event, onChange, fieldName, updatedFilteredSessions);
              }}
              style={{ width: "100%" }}
              value={val  ? val: ''}
            > 
              <option value="">Show All</option>
              {allTags.map(tag => {
                return (
                    <option key={tag} value={tag}>
                        {tag}
                    </option>
                );
            })}
            </select>
          );
        }      
        else {
        return (
          <select
            onChange={event => handleSelect(event, onChange, fieldName, filteredSessions)}
            style={{ width: "100%" }}
            value={val  ? val: ''}
          > 
            <option value="">Show All</option>
            {
            filteredSessions
            .map(item => item[fieldName])
            .filter((item, i, s) => !s.slice(0, i).some(x => typeof x === 'string' && x.includes(item)))
            .map(function (value) {
                return (
                <option key={value} value={value}>
                    {value}
                </option>
                 );
            })}
          </select>
        );
      }};
      const customSearch = (event) => {
        const matches = searchPublicSessions(sessions, event)
        setFilteredSessions(matches)
        setSelectedValues([])
        setActiveFilters(event.trim() ? [matches] : [])
      };
      const handleText = (event) => {
        setSelectedOption(event.target.value);
      };

      const handleClick = () => {
        customSearch(option)
      };

    const authors = desc['Authors']
    const credits = desc['Credits']
    const flavor_txt = desc['Description']
    const exp_txt = desc['Experiment']
    const exp_txt2 = desc['Experiment2']
    const exp_txt3 = desc['Experiment3']
    const pic = artwork ? artwork.figure : safeExternalUrl(desc['Image'])
    const opto = safeExternalUrl(desc['Optotagging'])
    const restrictedOpto = typeof opto === 'string' && opto.startsWith('https://firebasestorage.googleapis.com/v0/b/openscopetest-d7614.appspot.com/')
    const references = Array.isArray(desc.references)
      ? desc.references.map(reference => ({ ...reference, url: safeExternalUrl(reference && reference.url) })).filter(reference => reference.url)
      : []
    const caption = desc['Caption']
    const caption2 = desc['Caption2']
    const caption3 = desc['Caption3']
    const webinar = getProjectWebinar(catalogueProject, desc['Video'])

    var heads_ephys = ['sessionID', 'mouse', 'date', 'name',
    'probes', 'dandi', 'genotype', 'notes']
    var heads_ophys = ['mouse', 'sessionID', 'date', 'name',
    'planes','dandi', 'genotype', 'notes']
    if (catalogueProject && (!catalogueProject.firebaseProject || catalogueProject.sessionSource === 'dandi')) {
      const notesColumns = catalogueProject.firebaseProject ? ['notes'] : []
      heads_ephys = ['sessionID', 'mouse', 'date', 'name', 'probes', 'files', 'dandi', 'genotype', ...notesColumns]
        .filter(field => !['name', 'probes'].includes(field) || sessions.some(session => session[field]))
      heads_ophys = ['sessionID', 'mouse', 'date', 'name', 'planes', 'files', 'dandi', 'genotype', ...notesColumns]
        .filter(field => !['name', 'planes'].includes(field) || sessions.some(session => session[field]))
    }
    var head_defs = {
      mouse: "6 digit mouse id",
      sessionID: "10 digit ID",
      specimen: "10 digit Specimen ID",
      date: "The date the session was conducted",
      workflow: "LIMS status of the sessions",
      name: "The name of the presented Stimuli",
      probes: "A list of probes relevant to the session",
      path: 'The internal Allen Path',
      planes: 'Experimental id of planes acquired at the same time',
      files: 'Number of NWB assets grouped into this session',
      dandi: 'Upload location on dandi',
      genotype: 'The genotypic line of the mouse',
      status: "Current internal status of nwb conversion",
      fails: "failure tags of the session",
      flags: 'flagged tags of the session',
      overrides: 'override tags of the session',
      notes: 'internal notes relevant to session',
      Actions: 'Trigger Generation, Uploads, or Edit Notes'
      
    }
    var columns = []

    if (desc['Type'] ==='Ophys')
    {
        var column_heads = heads_ophys
    }
    else 
    {
        var column_heads = heads_ephys
    }
    var flagsArray = []
    for(var i = 0; i < column_heads.length; i++) {
        (function(column_head) {
           if (column_head === "flags"|| column_head==="overrides" || column_head === "fails")  {
            columns.push({
                Header: <ToolTipHeader header={column_head} tip={head_defs[column_head]}/>,
                accessor: column_head,
                minWidth: 250,
                Filter: ({ filter, onChange }) =>
                customFilter({ fieldName: column_head,filter, onChange }),
                filterAll: true,
                Cell: e => {
                    let flagsArray = e.original[column_head].split("/");
                    let flag_notes = e.original['flag_notes'].split("/");
                    let currentRow = 0;
                
                    return (
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", maxHeight:"100px", overflowY:"scroll", overflowX: "hidden", width:"100%"}}>
                            {flagsArray.map((flag, index) => {
                                if (index % 2 === 0) {
                                    currentRow++;
                                }
                                let cleanFlag = flag;

                                if (flag.match(/_\d+$/)) {
                                cleanFlag = flag.replace(/_\d+$/, '');
                                }
                
                                return (
                                    <div key={`${flag}-${currentRow}`} className="tag-row" style={{ display: "inline-block"}}>
                                      <Tag sessionID={e.original.sessionID} info={cleanFlag} notes={flag_notes[index]} def={definitions && definitions[cleanFlag] ? definitions[cleanFlag] : "no definition"} />
                                    </div>
                                  );                        
                            })}
                        </div>
                    );
                }
            })
           }
           else if (column_head === "dandi")
           {
            columns.push({
                Header: <ToolTipHeader header={column_head} tip={head_defs[column_head]}/>,
                accessor: column_head,
                maxwidth: 100,
                Filter: ({ filter, onChange }) =>
                customFilter({ fieldName: column_head,filter, onChange }),
                filterAll: true,
                Cell: e => {
                    const href = safeExternalUrl(e.original.dandi)
                    return href ? <a href={href}>{e.original.dandi}</a> : <span>{e.original.dandi}</span>
                }
           })
          }


           else 
           {
           columns.push({
              Header: <ToolTipHeader header={column_head} tip={head_defs[column_head]}/>,
              accessor: column_head,
              minWidth:150,
              filterMethod: (filter, rows) =>
                 matchSorter(rows, filter.value, { keys: [column_head] }),
                style: { fontSize: '14px', whiteSpace: 'normal', textOverflow: 'ellipsis' },
               Cell: e => {
                const cellContent = e.original[column_head];
                
                return (
                    <div className="cell-content" data-tip={cellContent} data-for={`tooltip-${e.index}`}  style={{ display: "inline-block"}}>
                        <CellTip sessionID={e.original.sessionID} info={cellContent}/>
                    </div>
                );
            },
              Filter: ({ filter, onChange }) =>
                 customFilter({ fieldName: column_head,filter, onChange }),
              filterAll: true
           });}
        })(column_heads[i]);
     }
    if (desc['Type'] === 'Ophys')
    {
       
    } else{
        
    }

    const datasetNavigation = multipleDatasets && (
      <nav className="project-dataset-navigation" aria-label="Project datasets">
        {projectGroup.datasets.map(dataset => <Link key={dataset.id} to={`/projects/${dataset.id}`}
          aria-current={dataset.id === catalogueProject.id ? 'page' : undefined}>
          <span>{dataset.modality}</span>
          <span className="dataset-navigation-id">DANDI {dataset.dandiset}</span>
        </Link>)}
      </nav>
    )
    const projectLinks = (
      <nav className="project-links project-resources" aria-label="Project resources">
        <Link to="/projects"><FaArrowLeft aria-hidden="true" /> All projects</Link>
        <a href="#public-sessions" className="resource-primary"><FaTable aria-hidden="true" /> Session table</a>
        {webinar && <a href={webinar.watchUrl} target="_blank" rel="noopener noreferrer" title={webinar.title}>
          <FaYoutube aria-hidden="true" /> {webinar.label} on YouTube
        </a>}
        {references.length > 0 && <a href="#project-references">Papers and code</a>}
        {catalogueProject && <>
          {databookUrl && <a href={databookUrl} target="_blank" rel="noopener noreferrer">
            <FaBookOpen aria-hidden="true" /> Databook
          </a>}
          <a href={`https://dandiarchive.org/dandiset/${catalogueProject.dandiset}`} target="_blank" rel="noopener noreferrer">
            <FaExternalLinkAlt aria-hidden="true" /> DANDI
          </a>
          {stimulusCode && <a href={stimulusCode.url} target="_blank" rel="noopener noreferrer"
            aria-label="Stimulus code on GitHub" title={stimulusCode.detail || stimulusCode.title}>
            <FaGithub aria-hidden="true" /> Stimulus code
          </a>}
        </>}
      </nav>
    )
    if (loading || loadError) {
      return (
        <main className="public-session-page">
          <h2>{projectGroup ? projectGroup.name : project}</h2>
          {datasetNavigation}
          {projectLinks}
          <p role={loadError ? 'alert' : 'status'}>{loadError || 'Loading public sessions...'}</p>
          {loadError && <button type="button" className="session-retry" onClick={() => setLoadAttempt(attempt => attempt + 1)}>
            <FaRedo aria-hidden="true" /> Retry
          </button>}
        </main>
      )
    }
    {
        console.log("DEFS ARE", definitions)
        const counts = countPublicSessions(sessions)
        return (
            <main className="public-session-page">
            <header className="project-page-heading">
              <div>
                <p className="section-eyebrow">{catalogueProject ? `DANDI ${catalogueProject.dandiset}` : 'OpenScope'} / {desc.Type === 'Ophys' ? 'Optical physiology' : 'Electrophysiology'}</p>
                <h2>{projectGroup ? projectGroup.name : project}</h2>
                {projectGroup && <p className="project-deck">{projectGroup.summary}</p>}
              </div>
              <div className="project-page-counts">
                <span>{sessions.length} public sessions</span>
                {counts.mice !== null && <span>{counts.mice} {counts.mice === 1 ? 'mouse' : 'mice'}</span>}
                {multipleDatasets && <small>{catalogueProject.modality} dataset</small>}
              </div>
            </header>
            {datasetNavigation}
            {projectLinks}
            {dataSource && <p className="session-provenance">
              {dataSource.label}{dataSource.draft ? ' (draft dataset)' : ''}
              {dataSource.retrievedAt && `; metadata retrieved ${dataSource.retrievedAt.slice(0, 10)}`}
            </p>}
            <section className="project_details" aria-label="Project details">
                <div className="project-prose">
                  <p className="section-eyebrow">Study overview</p>
                  {credits && <h3 className="study-title">{credits}</h3>}
                  {authors && <p className="project-authors">{authors}</p>}
                  {flavor_txt && <p>{flavor_txt}</p>}
                  {(exp_txt || exp_txt2 || exp_txt3) && <h3>Experimental design</h3>}
                  {exp_txt && <p>{exp_txt}</p>}
                  {exp_txt2 && <p>{exp_txt2}</p>}
                  {exp_txt3 && <p>{exp_txt3}</p>}
                  {opto && <h3>Optotagging</h3>}
                  {opto && !restrictedOpto && !unavailableImages.opto && <img src={opto} alt="Optotagging experiment" loading="lazy"
                    onError={() => setUnavailableImages(previous => ({ ...previous, opto: true }))} />}
                  {restrictedOpto && <p>Original optotagging figure unavailable. <a href="https://alleninstitute.github.io/openscope_databook/optotagging/" target="_blank" rel="noopener noreferrer">Optotagging analysis</a></p>}
                  {unavailableImages.opto && <p role="status">Optotagging figure unavailable.</p>}
                </div>
                <aside className="project-media" aria-label="Project media">
                  {pic && <figure className="project_image">
                    <div className="media-heading"><h3>Experimental stimulus</h3>
                      <a href={pic} target="_blank" rel="noopener noreferrer" aria-label="Open full-size stimulus figure" title="Open full-size stimulus figure"><FaExternalLinkAlt aria-hidden="true" /></a>
                    </div>
                    {!unavailableImages.project && <img src={pic} alt={artwork ? artwork.alt : `${project} experiment`} loading="lazy"
                      onError={() => setUnavailableImages(previous => ({ ...previous, project: true }))} />}
                    {unavailableImages.project && <p role="status">Project figure unavailable. {databookUrl &&
                      <a href={databookUrl} target="_blank" rel="noopener noreferrer">Databook figures</a>}
                    </p>}
                    {(caption || caption2 || caption3) && <figcaption>
                      {caption && <p>{caption}</p>}
                      {caption2 && <p>{caption2}</p>}
                      {caption3 && <p>{caption3}</p>}
                    </figcaption>}
                  </figure>}
                  {webinar && <div className="project-video">
                    <div className="media-heading"><h3>{webinar.label}</h3>
                      <a href={webinar.watchUrl} target="_blank" rel="noopener noreferrer" aria-label="Watch presentation on YouTube" title="Watch presentation on YouTube"><FaYoutube aria-hidden="true" /></a>
                    </div>
                    <iframe src={webinar.embedUrl} title={`${catalogueProject ? catalogueProject.name : project} ${webinar.label.toLowerCase()}`}
                      loading="lazy" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen />
                  </div>}
                </aside>
              </section>
              <div className="project_table" id="public-sessions" ref={sessionTableRef}>
              <div className="session-toolbar">
                <h3>Session data</h3>
                <form className="session-search" onSubmit={event => { event.preventDefault(); handleClick(); }}>
                  <label htmlFor="session-search">Search sessions</label>
                  <input type="text" id="session-search" onChange={handleText} value={option} />
                  <button type="submit" aria-label="Apply session search" title="Apply session search"><FaSearch aria-hidden="true" /></button>
                </form>
                </div>
    
            <ReactTable
                data={activeFilters && activeFilters.length && definitions? filteredSessions : sessions}
                filterable
                defaultFilterMethod={(filter, row) => 
                    String(row[filter.id]) === filter.value} 
                    columns = {columns}          
                        defaultExpanded={true}
                        defaultPageSize={10}
                        height={300}
                        noDataText="No public sessions found."
            />      
                <div>
                                      {isOpen && <Popup
                                      content={<>
                                      <textarea
                                      value={currentNotes}
                                      onChange={handleCurrentNotes}>
                                          {editNotes}
                                      </textarea>
                                      <EditNoteButton
                                      notes={currentNotes}
                                      sessionID={currSess}
                                      loadStatus={setEditNotes}/>
                                      </>}
                                      handleClose={togglePopup}
                                  />}
                </div>
              </div>
              {references.length > 0 && <section className="project-references" id="project-references" aria-labelledby="references-heading">
                <h3 id="references-heading">Papers and code</h3>
                <ul>{references.map(reference => <li key={reference.url}>
                  <span className="reference-kind">{reference.kind}</span>
                  <a href={reference.url} target="_blank" rel="noopener noreferrer">{reference.title}</a>
                  {reference.detail && <span className="reference-detail">{reference.detail}</span>}
                </li>)}</ul>
              </section>}
            </main>
        );
    }
   
}